import axios from 'axios';

export class AiCoreImageService
{
    private static getUrl()
    {
        const config = useRuntimeConfig();

        return config.public.localApiUrl;
    }

    private static getAuthHeader()
    {
        const { $auth } = useAuth();

        return { Authorization: `Bearer ${$auth.token()}` };
    }

    public static async fetchPredictions(params: {
        provider: string;
        owner: string;
        name: string;
    })
    {
        return (await axios.get<any>(`${this.getUrl()}/aicore/image/predictions`, { params, headers: this.getAuthHeader() })).data;
    }

    public static async createPrediction(model: any, params: {
        provider: string;
        owner: string;
        name: string;
    })
    {
        return (await axios.post<any>(`${this.getUrl()}/aicore/image/predictions`, model, { params, headers: this.getAuthHeader() })).data;
    }

    public static async fetchSchema(params: {
        provider: string;
        owner: string;
        name: string;
    })
    {
        return (await axios.get<any>(`${this.getUrl()}/aicore/image/schema`, { params, headers: this.getAuthHeader() })).data;
    }

    public static async saveImages(model: SaveImagesRequestModel, payload: any, scope: string, folder?: number, secured: boolean = false)
    {
        return (await axios.post<any[]>(`${this.getUrl()}/aicore/image/save`, {
            urls: model.urlList,
            prompt: model.prompt,
            container: 'default',
            payload: payload,
            secured: secured,
            scope: scope,
            folder: folder
        }, { headers: this.getAuthHeader() })).data;
    }
}

export default AiCoreImageService;

export interface ModelSchemaField
{
    'title'?: string;
    'description'?: string;
    'type': string;
    'format'?: string;
    'default'?: any;
    'minimum'?: number;
    'maximum'?: number;
    'x-order'?: number;
    'enum'?: string[];
    'allOf'?: { enum?: string[]; $ref?: string }[];
}

export interface Prediction
{
    id: string;
    status: string;
    output: string[] | string | null;
    input: Record<string, any>;
    completed_at: string;
    model: string;
}

export interface SaveImagesRequestModel
{
    urlList: string[];
    prompt: string;
}
